module.exports = __webpack_public_path__ + "ef27bdfefef167ccab4862237ff0dd4a.pdf";